import React, { Component } from 'react';
import { Link } from 'gatsby';
import logo from '../img/effi-logo-colored.webp';
// import Topsection from './Topsection';

export default class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openMenu: false,
      visibilityClass: '',
    };
  }
  toggleMenu = value => {
    this.setState({ openMenu: value });
  };
  handleScroll = () => {
    const { visibilityClass } = this.state;
    if (window.pageYOffset > 60) {
      if (visibilityClass !== 'navbar-shrink') {
        this.setState({ visibilityClass: 'navbar-shrink' });
      }
    } else {
      if (visibilityClass === 'navbar-shrink') {
        this.setState({ visibilityClass: '' });
      }
    }
  };

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  render() {
    const { openMenu, visibilityClass } = this.state;
    return (
      <nav
        className={`navbar navbar-expand-md navbar-light fixed-top ${visibilityClass}`}
        id="mainNav"
      >
        <div className="container">
          <Link className="navbar-brand" to="/" aria-label="Navbar Brand">
            <img src={logo} className="img-fluid logo" alt="Effi logo" />
          </Link>

          {/* <button
            onClick={_ => this.toggleMenu(!openMenu)}
            className={`navbar-toggler navbar-toggler-right ${
              openMenu ? '' : 'collapsed'
            }`}
            type="button"
            aria-controls="navbarResponsive"
            aria-expanded={openMenu}
            aria-label="Toggle navigation"
          >
            <i className="fas fa-bars"></i>
          </button> */}
          <a
            className=" ml-auto d-md-none"
            href="/pricing"
            target="_blank"
            rel="noreferrer noopener"
          >
            Pricing
          </a>
          <a
            className="btn btn-primary ml-4 d-flex d-md-none"
            href="https://broker.effi.com.au"
            target="_blank"
            rel="noreferrer noopener"
          >
            Broker Login
          </a>

          <div
            className={`collapse navbar-collapse ${openMenu ? 'show' : ''}`}
            id="navbarResponsive"
          >
            <ul className="navbar-nav ml-auto">
              {/* <li className="nav-item">
                <Scroll
                  onClick={_ => this.toggleMenu(!openMenu)}
                  type="id"
                  element="about"
                >
                  <a className="nav-link" href="#about">
                  Find a broker
                  </a>
                </Scroll>
              </li> */}

              <li className="nav-item mx-4 my-auto">
                <Link className="" to="/pricing">
                  Pricing
                </Link>
                {/* <SubscribeForm /> */}
              </li>
              <li className="nav-item mt-3 mb-3 ml-3">
                <a
                  className="btn btn-primary"
                  href="https://broker.effi.com.au/"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  Broker Login
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}
